module.exports = __webpack_public_path__ + "img/28.6c8a388b.jpg";